import { TOUR_SCREENS } from './onboarding-config';

export interface TourStep {
    key: string;
    route: string;
    /** Element the spotlight highlights — the sidebar nav item for this screen. */
    selector: string;
    title: string;
    body: string;
}

const COPY: Record<string, { title: string; body: string }> = {
    Dashboard: {
        title: 'Dashboard',
        body: 'Your project home — an overview of progress across every IPOP review.'
    },
    review_1: {
        title: 'Review 1 — Customers & Solutions',
        body: 'Define who your customers are, how well your solution fits, and the company-fit analysis.'
    },
    review_2: {
        title: 'Review 2 — Definition of success',
        body: 'Set what success looks like: activity chain, economic model, benefits and skills.'
    },
    review_3: {
        title: 'Review 3 — Factors',
        body: 'Capture the key factors and stakeholders that influence your project.'
    },
    review_4: {
        title: 'Review 4 — Moves',
        body: 'Plan your moves, IP, timeline and budget to turn the analysis into action.'
    },
    unknowns: {
        title: 'Unknowns',
        body: 'Track open questions and assumptions you still need to validate.'
    },
    validations: {
        title: 'Validations',
        body: 'Review and confirm the inputs that have been validated across the project.'
    },
    reports: {
        title: 'Reports',
        body: 'Generate and export a polished report of your innovation analysis.'
    }
};

/** One step per sidebar screen (built from TOUR_SCREENS so the two stay in sync). */
export const TOUR_STEPS: TourStep[] = TOUR_SCREENS.map((screen) => ({
    key: screen.key,
    route: screen.route,
    selector: `[data-tour="${screen.key}"]`,
    title: COPY[screen.key]?.title ?? screen.label,
    body: COPY[screen.key]?.body ?? ''
}));
